import React from 'react';
import LeftOutlined from '@ant-design/icons/LeftOutlined';
import RightOutlined from '@ant-design/icons/RightOutlined';
import Button from '../button/Button';
function getArrowIcon(type, direction) {
    const isRight = type === 'right';
    if (direction !== 'rtl') {
        return isRight ? React.createElement(RightOutlined, null) : React.createElement(LeftOutlined, null);
    }
    return isRight ? React.createElement(LeftOutlined, null) : React.createElement(RightOutlined, null);
}
const Action = ({ type, actions, moveToLeft, moveToRight, leftActive, rightActive, direction, disabled, }) => {
    const isRight = type === 'right';
    const button = isRight ? actions[0] : actions[1];
    const moveHandler = isRight ? moveToRight : moveToLeft;
    const active = isRight ? rightActive : leftActive;
    const icon = getArrowIcon(type, direction);
    if (React.isValidElement(button)) {
        const element = button;
        const mergedDisabled = element.props.disabled || disabled || !active;
        const onClick = (event) => {
            if (mergedDisabled) {
                event.preventDefault();
                return;
            }
            element?.props?.onClick?.(event);
            moveHandler?.(event);
        };
        return React.cloneElement(element, {
            disabled: mergedDisabled,
            onClick,
        });
    }
    return (React.createElement(Button, { type: "primary", size: "small", disabled: disabled || !active, onClick: (event) => moveHandler?.(event), icon: icon }, button));
};
const Actions = (props) => {
    const { className, style, oneWay, actions, ...restProps } = props;
    return (React.createElement("div", { className: className, style: style },
        React.createElement(Action, { type: "right", actions: actions, ...restProps }),
        !oneWay && React.createElement(Action, { type: "left", actions: actions, ...restProps }),
        actions.slice(oneWay ? 1 : 2)));
};
if (process.env.NODE_ENV !== 'production') {
    Actions.displayName = 'Actions';
}
export default Actions;
